"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCarouselErrorEventCallbacks = createCarouselErrorEventCallbacks;
function createCarouselErrorEventCallbacks(contextRef) {
    return {
        community_carousel_error: function (carousel, errorMessage) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('community_carousel_error', {
                context: 'community',
                carousel: carousel,
                error_message: errorMessage,
            });
        },
    };
}
